<div class="container-base-dados">
  <div class="seletores-base">
    <app-select-one
      label="Plataforma"
      placeholder="Selecione a plataforma"
      heightFormField="40px"
      [listaInput]="plataformas"
      [campo]="'nome'"
      [habilitarBusca]="true"
      [desselecionar]="true"
      [disabled]="!podeEditar || carregandoPlataformas"
      [itemSelecionado]="plataformaSelecionada"
      (selecionarItem)="selecionarPlataforma($event)">
    </app-select-one>

    <app-select-one
      label="Base dinâmica"
      placeholder="Selecione a base"
      heightFormField="40px"
      [listaInput]="bases"
      [campo]="'nome'"
      [habilitarBusca]="true"
      [desselecionar]="true"
      [disabled]="!podeEditar || !plataformaSelecionada || carregandoBases"
      [itemSelecionado]="baseSelecionada"
      (selecionarItem)="selecionarBase($event)">
    </app-select-one>
  </div>

  @if (carregandoPlataformas || carregandoBases || (isCarregando && contatos.length === 0)) {
    <app-tabela-skeleton [qntdLinhas]="5"></app-tabela-skeleton>
  } @else {
    @if (baseSelecionada) {
      <div class="cabecalho-lista">
        <div class="orientacao-base">
          <span>Para visualizar a base dinâmica completa,
            <button type="button" class="botao-base-completa" (click)="abrirBaseCompleta()">
              clique aqui
            </button>
          </span>
          @if (exibirReenvioIntegracao) {
            <button type="button"
                    class="botao-reenvio-integracao"
                    [disabled]="reenviandoIntegracao"
                    (click)="reenviarIntegracao.emit()">
              {{ reenviandoIntegracao ? 'Reenviando...' : 'Enviar integração novamente' }}
            </button>
          }
        </div>
        <span class="contador-contatos" matTooltip="Total de contatos na base">{{ totalContatos ?? 0 }}</span>
      </div>
    }
    @if (contatos.length > 0) {
      <div class="table-container">
        <mat-table [dataSource]="contatosTable" style="width: calc(100% - 10px);">
          <ng-container matColumnDef="nome">
            <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
            <mat-cell *matCellDef="let elemento">
              <span class="ellipse" [matTooltip]="elemento.nome">{{ elemento.nome ?? '--' }}</span>
              @if (!elemento.nome?.trim()) {
                <img class="icone-aviso" src="assets/icones/exclamacao.svg" matTooltip="Nome inválido" alt="Nome inválido">
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="cpf">
            <mat-header-cell *matHeaderCellDef> CPF/CNPJ </mat-header-cell>
            <mat-cell *matCellDef="let elemento">
              <span class="ellipse" [matTooltip]="elemento.cpf | cpfCnpjMask">{{ elemento.cpf ? (elemento.cpf | cpfCnpjMask) : '--' }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="telefone">
            <mat-header-cell *matHeaderCellDef> Número p/ envio </mat-header-cell>
            <mat-cell *matCellDef="let elemento">
              <span class="ellipse" [matTooltip]="elemento.telefone | celularMask">{{ (elemento.telefone | celularMask) ?? '--' }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef> E-mail </mat-header-cell>
            <mat-cell *matCellDef="let elemento">
              <span class="ellipse" [matTooltip]="elemento.email">{{ elemento.email ?? '--' }}</span>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>

        <!-- <p class="rodape-tabela">Prévia de {{ contatos.length }} de {{ totalContatos }} contato(s)</p> -->
      </div>
    } @else {
      <div class="flex center-center estado-vazio">
        <app-balao-informativo
          [titulo]="baseSelecionada ? 'Base Sem Contatos' : plataformaSelecionada ? 'Nenhuma Base Selecionada' : 'Nenhuma Plataforma Selecionada'"
          [texto]="baseSelecionada ? 'A base selecionada não retornou contatos no momento.' : plataformaSelecionada ? 'Selecione uma base dinâmica para carregar a prévia dos contatos.' : 'Selecione uma plataforma para listar exclusivamente as bases disponíveis nela.'"
          [width]="'249px'"
          [heigth]="'122px'">
        </app-balao-informativo>
      </div>
    }
  }
</div>
